export default {"src":"/_next/static/media/ic_calendar.3c7891f2.svg","height":18,"width":22,"blurWidth":0,"blurHeight":0};